//console.log('dell')

    var $page = jQuery('.fixed-appointment--scheme');
    var $servicesView = $page.find('.animation-services');

    var $listItem = $servicesView.find('.list-item');
    var $link = $servicesView.find('.link');
    var $chosen = $servicesView.find('.chosen');
    var $control = $servicesView.find('.control');
    var $openDropdown = $servicesView.find('#dropdownMenu1');
    var $dropdownMenu = $servicesView.find('.dropdown-menu');
    var math = {
        '+': function (a, b) {
            return a + b
        },
        '-': function (a, b) {
            return a - b
        },
    };

    $openDropdown.on('click', function (e) {
        console.log('click');
        $dropdownMenu.toggleClass('shown');
    });

    // $(document).on("click", function (e) {
    //     if( $('.dropdown-menu.shown').length > 0 && $(e.target).closest( '.dropdown-menu.shown' ).length == 0 ){
    //         $('.dropdown-menu.shown').removeClass('shown');
    //     }
    // });

    $link.on('click', function () {
        //console.log('click on link')
        var id = $(this).data('id');
        var text = $(this).text();
        $chosen.text(text).data('id',id);
        setService(id);
        $dropdownMenu.toggleClass('shown');
    });

    $control.on('click', function () {
        var id = _getActiveService();
        var timeType = $(this).parent().data('time-type');
        var operator = $(this).data('control');

        setTime($(this), id, timeType, operator);

    });

    function setTime($control, id, timeType, operator) {
        var $timing;
        var boundary;
        if (id === 'all') {
            $timing = $listItem.find("[class=" + timeType + "]");
        } else {
            $timing = $listItem.eq(id).find("[class=" + timeType + "]");
        }

        var time = math[operator](+$timing.html(), 1);

        if (timeType === 'hour') {
            boundary = 12
        }
        if (timeType === 'minute') {
            boundary = 59
        }
        if (time > boundary) {
            time = 0
        }
        if (time < 0) {
            time = boundary
        }

        var zeroPrefix = time < 10 ? '0' : '';

        $control.parent().siblings('.time').html(zeroPrefix + time);
        $timing.html(zeroPrefix + time);
    }

    function _getActiveService() {
        return $chosen.data('id')
    }

    function setService(id) {
        if (id === 'all') {
            $listItem.show()
        } else {
            $listItem.hide();
            $listItem.eq(id).show();
        }
    }

